module.exports = __webpack_public_path__ + "img/logos2m.130ff85a.svg";